<template>
  <div>
    <form @submit.prevent="searchGroup">
      <div class="inline-search-form">
        <div class="form-group">
          <label for="groupName" v-show="groupName.length == 0">Name or ID:</label>
          <input
            type="text"
            id="groupName"
            name="groupName"
            v-model="groupName"
          />
        </div>
        <button type="submit" class="btn --sm">Search</button>
      </div>
    </form>
    <app-advanced-table
      title="Group Results"
      :headers="groupHeaders"
      id="search-groups"
      :items="computedSelfGroupsArray"
      @cellClicked="group => groupClicked(group)"
      :search="groupSearch"
      :rowsPerPage="3"
      :clickable="true"
    >
      <template
        #items="{ item, visibleHeaders, getCellValue }"

      >
        <tr>
          <template v-for="(header, index) in visibleHeaders">
            <truncate-concat
              @clicked="groupClicked(item)"
              v-if="header.truncate"
              :tabbable="true"
              :maxChars="header.maxChars"
              :key="index"
              :value="getCellValue(item, header)"
              class="-link-style"
              tag="td"
            />
            <td
              v-else-if="header.value === 'groupDetails'"
              :key="index">
              <a href="javascript:void(0)" @click.stop="goToGroup(item)">View Details</a>
            </td>
            <td
              v-else-if="header.value === 'select'"
              @click.prevent="groupClicked(item)"
              class="-link-style"
              :key="index"
            >
              <a href="javascript:void(0)" @click.stop="groupClicked(item)">
                Select
              </a>
            </td>
            <td
              v-else
              @click.stop="groupClicked(item)"
              :key="index"
            >
              <a href="javascript:void(0)" @click.stop="groupClicked(item)">
                {{ getCellValue(item, header) }}
              </a>
            </td>
          </template>
        </tr>
      </template>
    </app-advanced-table>
  </div>
</template>

<script>
  import AppAdvancedTable from '@organisms/AdvancedTable.vue'
  import groupSelection from '@mixins/groupSelection'
  import TruncateConcat from '@atoms/ConcatAndEllipseValues.vue'
  import { mapActions } from 'vuex'

  export default {
    mixins: [groupSelection],
    components: {
      AppAdvancedTable,
      TruncateConcat
    },
    data() {
      return {
        groupName: '',
        groupId: '',
        groupHeaders: [
          {
            text: 'Group',
            align: 'left',
            value: 'group',
            truncate: true,
            maxChars: 85
          },
          { text: 'Group Details', value: 'groupDetails' },
          { text: '', value: 'select', sortable: false },
          { text: 'Group CK', value: 'groupCk', visible: false }
        ]
      }
    },
    methods: {
      ...mapActions('portalContext', {
        groupClicked: 'SELECT_GROUP'
      })
    },
    computed: {
      groupSearch() {
        return this.groupName.trim()
      }
    }
  }
</script>
